import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import ChartCard, { TOOLTIP_STYLE } from "@/components/charts/ChartCard";

export default function SalespersonChart({ data = [], className, testid = "salesperson-chart" }) {
  const rows = data.slice(0, 10).map((r) => ({ ...r, short: r.name.split(" ")[0] }));
  const hasData = rows.some((r) => r.leads || r.won || r.activities);
  return (
    <ChartCard title="Salesperson comparison" subtitle="Leads, activities and won deals per person" testid={testid} className={className}
      empty={!hasData ? "No salesperson activity in this period" : null}>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={rows} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
          <XAxis dataKey="short" tick={{ fontSize: 11, fill: "#64748B" }} interval={0} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12, fill: "#64748B" }} />
          <Tooltip contentStyle={TOOLTIP_STYLE} cursor={{ fill: "#F1F5F9" }} labelFormatter={(_, p) => p?.[0]?.payload?.name || ""} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="leads" name="Leads" fill="#0D9488" radius={[4, 4, 0, 0]} />
          <Bar dataKey="activities" name="Activities" fill="#0284C7" radius={[4, 4, 0, 0]} />
          <Bar dataKey="won" name="Won" fill="#D97706" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
